.modalContainer {
  width: 327px;
  padding: 24px;

  @media (--reefer-media-tablet-min) {
    width: 592px;
  }
}

.layeredOverlay.layeredOverlay {
  z-index: calc(var(--layers-modal) + 5);
}

.productCard {
  @media (--reefer-media-tablet-max) {
    margin-bottom: 8px;
  }
}

.doneButton {
  margin-top: 8px;

  @media (--reefer-media-tablet-min) {
    margin-top: 16px;
  }
}

.textContrastColor {
  color: var(--colors-text-inverse);
}
